import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import $ from "jquery";
import Flickity from 'react-flickity-component'
import { NavLink } from 'react-router-dom';
import { Badge, Divider, Input, InputGroup, List, Drawer, Animation, Button } from 'rsuite';


export default class Blog extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            curent_item: null,
            blog: null,
            step: 1,

        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {

        Send('page/blog/list', "", true).then((res) => {
            this.setState({
                blog: res.data.blog,
            });
        }).catch((err) => { });


    }

    //------------------ step_change-----------------------

    step_change = (id) => {
        this.setState({ step: id });
    }


    // ---------------- GetDay --------------------------

    GetSubject = (thesubject) => {
        this.setState({ curent_item: thesubject });
        this.step_change(2)
    }




    render() {

        H1.page_name("آشنایی بیشتر");

        return (


            <div className="h-100 mt-4">





                {this.state.step === 1 &&
                    <>


                        <div className='c-row'>

                            <div className="text-center mb-2 py-2 position-relative">

                                {/* <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span> */}
                                <span className='fs-6'> آشنایی بیشتر </span>


                            </div>

                        </div>



                        <div className='c-row'>

                            <img className='cover br-16 mb-3' src="/img/blog_z.jpg" width="100%" height="auto" onClick={() => this.GetSubject('z')} />

                            <img className='cover br-16 mb-3' src="/img/blog_r.jpg" width="100%" height="auto" onClick={() => this.GetSubject('r')} />

                            <img className='cover br-16 mb-3' src="/img/blog_t.jpg" width="100%" height="auto" onClick={() => this.GetSubject('t')} />


                        </div>


                    </>
                }




                {this.state.step === 2 &&
                    <>


                        <div className='c-row'>

                            <div className="text-center mb-2 py-2 position-relative">

                                <Animation.Bounce in={true}>
                                    <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.step_change(1)}></span>
                                </Animation.Bounce>
                                <span className='fs-6'>


                                    {this.state.curent_item === 'r' ? 'رژیم‌ها' : this.state.curent_item === 'z' ? 'سبک زندگی' : this.state.curent_item === 't' && 'کلاس‌های ورزشی'}


                                </span>


                            </div>

                        </div>



                        <div className='c-row  mt-5'>

                            {this.state.blog.filter(blog => blog.cat == this.state.curent_item).map((item, index) => [

                                <NavLink exact="true" to={'/blog/' + item.id} key={index}>
                                        <div className='bg-white video-box br-16'>
                                            <img className='cover img-fit' src={item.cover ?? '/img/not.png'}  height="170" />
                                            <div className="info px-4 py-3 text-start">
                                                <div className="text-nowrap text-black"> {item.name}</div>
                                            </div>
                                        </div>
                                </NavLink>

                            ])}




                        </div>


                    </>
                }





            </div>


        )
    }
}

